/**
 * contains the abi and contract address
*/

class ResampleContract {
    constructor() {
        this.abi = [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "samplesAddress",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "resampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleUsed",
				"type": "bytes32"
			}
		],
		"name": "NewResample",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "resampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "string",
				"name": "title",
				"type": "string"
			},
			{
				"internalType": "bytes32[4]",
				"name": "tags",
				"type": "bytes32[4]"
			},
			{
				"internalType": "bytes32[]",
				"name": "samplesUsedHashes",
				"type": "bytes32[]"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "newResample",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
        ];
        
        this.contractAddress = '0xD914528749Fcfc2945148551d0F61AfDFe429962';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default ResampleContract;
